import React from "react";

/**
 * These are only defaults and we'll provide their values when using the wrapper component.
 */
const Context = React.createContext({
    filters: {
        category: [],
        sort: null,
        limit: null,
        offset: null,
    },
    data: {
        loading: false,
        error: false,
        queryResult: null,
    },
    // paginator: {
    //     pageCount: null,
    //     currentPage: 0,
    // },

    updateFilters: () => {},
    getFiltersInitial: () => {},
    // updatePaginator:  () => {},
    transformStructure: () => {},
});

export default Context;